// src/redux/actions/siteActions.js
export const SET_SITE_LIST = 'SET_SITE_LIST';

export const setSiteList = (siteList) => ({
  type: SET_SITE_LIST,
  payload: siteList,
});
